module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_index clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 apply_btm_left"
  }, [_c('section', {
    staticClass: "p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("管理应用")]), _vm._v(" "), _c('div', {
    staticClass: "manage_app_box text-center"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "btn btn_create",
    on: {
      "click": function($event) {
        return _vm.routerToPage('/add_app')
      }
    }
  }, [_vm._v("创建应用")])]), _vm._v(" "), _c('section', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "btn btn_manage",
    on: {
      "click": function($event) {
        return _vm.routerToPage('/all_app')
      }
    }
  }, [_vm._v("应用管理")])])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "tip_sub_text"
  }, [_vm._v("共" + _vm._s(_vm.applyNum) + "款应用")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 apply_btm_right"
  }, [_c('section', {
    staticClass: "p_background"
  }, [_c('h3', {
    staticClass: "all_title clearfix"
  }, [_vm._v("\n\t\t\t\t\t\t消息列表\n\t\t\t\t\t\t"), _c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/message_list"
    }
  }, [_vm._v("更多>>")])], 1), _vm._v(" "), _c('div', {
    staticClass: "message_list_box"
  }, [(_vm.msglist.length == 0) ? _c('p', {
    staticClass: "text-center color_9"
  }, [_vm._v("暂无消息")]) : _vm._l((_vm.msglist), function(msg) {
    return _c('p', {
      staticClass: "cursor"
    }, [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.view(msg.id)
        }
      }
    }, [_c('span', {
      staticClass: "message_list_title text-right text-space",
      domProps: {
        "innerHTML": _vm._s(msg.messageTitle)
      }
    }), _vm._v(":\n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "message_list_text text-space"
    }, [_vm._v(_vm._s(msg.messageComment))]), _vm._v(" "), _c('span', {
      staticClass: "message_list_time text-right"
    }, [_vm._v(_vm._s(_vm._f("datetime")(msg.messageSendTime)))])])])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p_background apply_top"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("统计信息")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "statistical_information"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-339753bb"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/app_index.vue
// module id = 1247
// module chunks = 1